import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import { Table } from 'elemental-react16'
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import shop from "shop/shop"
import Responsive from "react-responsive"

class ReturnPageContact extends Component {
    state = {
        glnNumber: '',
        saison: ''
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }

    componentDidMount() {
        if(!shop.delivery){
          console.log("shop.delivery is empty")
          this.props.history.push("/return")
        }
      }

    render() {
        if(!shop.delivery){
            console.log("shop.delivery is empty")
            this.props.history.push("/return")
            document.location.reload()
            return null
        }
        return (
            <Fragment>

            </Fragment>
        );
    }
}

export default ReturnPageContact;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageContact.js